import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DEFAULT_LOCALE, Locale } from 'helpers/consts';
import en from 'helpers/intl/en-en';
import nl from 'helpers/intl/nl-nl';

interface IIntlState {
  locale: Locale;
}

const initialState: IIntlState = {
  locale: DEFAULT_LOCALE,
};

export const getMessagesForLocale = (locale: Locale) => {
  switch (locale) {
    case 'en':
      return en;
    case 'nl':
      return nl;
    default:
      return en;
  }
};

const intlSlice = createSlice({
  name: 'intl',
  initialState,
  reducers: {
    setLocale: (state, action: PayloadAction<Locale>) => {
      state.locale = action.payload;
    },
    rehydrate: (state, action) => {
      const locale = action.payload?.locale || initialState.locale;
      state.locale = locale;
    },
  },
});

export const { setLocale } = intlSlice.actions;
export default intlSlice.reducer;
